import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=186585ce&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('186585ce')) {
      api.createRecord('186585ce', component.options)
    } else {
      api.reload('186585ce', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=186585ce&", function () {
      api.rerender('186585ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/layout/Sidebar.vue"
export default component.exports